// extracted by mini-css-extract-plugin
module.exports = {"global_marker":"adformat_global_marker__EZUc8"};